export default [{
    title: 'production',
    id: null,
}, {
    title: 'beta',
    config: {
        apiUrl: '{apiHost}/api/beta',
    },
}];
